import { render, staticRenderFns } from "./PresentationRoot.vue?vue&type=template&id=ea2050c8&scoped=true&"
import script from "./PresentationRoot.vue?vue&type=script&lang=ts&"
export * from "./PresentationRoot.vue?vue&type=script&lang=ts&"
import style0 from "./PresentationRoot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2050c8",
  null
  
)

export default component.exports